export const Subjective = 0
export const Objective = 1

export const all = [
    { label: 'Subjective', value: 0, translate: 'exam:subjective' },
    { label: 'Objective', value: 1, translate: 'exam:objective' },
]
